import { createTheme, ThemeProvider } from "@mui/material/styles";
import { PropsWithChildren } from "react";

export default function AppThemeProvider({ children }: PropsWithChildren<{}>) {
    return <ThemeProvider theme={DefaultTheme}>
        {children}
    </ThemeProvider>
}

const DefaultTheme = createTheme({
    palette: {
        mode: "dark",
    },
    components: {
        MuiAlert: {
            defaultProps: {
                elevation: 6,
                variant: "outlined"
            }
        },
        MuiTextField: {
            defaultProps: {
                variant: "outlined"
            }
        }
    }
});